import { render } from "./AssistenteConhecimentoAdminLayout.vue?vue&type=template&id=7089831f&scoped=true"
import script from "./AssistenteConhecimentoAdminLayout.vue?vue&type=script&lang=js"
export * from "./AssistenteConhecimentoAdminLayout.vue?vue&type=script&lang=js"

import "./AssistenteConhecimentoAdminLayout.vue?vue&type=style&index=0&id=7089831f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7089831f"]])

export default __exports__